// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPINetworkInstance } from 'common/api';

// Types
import { ActionGetUrlSetupAPI, getUrlSetupAPIError, getUrlSetupAPISuccess, } from './actions';

function* getUrlSetup(action: ActionGetUrlSetupAPI) {
    try {
        const connection  = "DealerOn Support";
        const dealerId  = action.dealerId;
        const { data } = yield call(createAPINetworkInstance().get, `/urls/${connection}/dealer/${dealerId}`);
        yield put(getUrlSetupAPISuccess(data));
    } catch (err) {
        yield put(getUrlSetupAPIError(err));
    }
}

export default function* urlSagas() {
    yield takeLatest(ACTIONS.GET_URLSETUP_API_REQUEST, getUrlSetup);
}
